"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUploadDocument = void 0;
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var react_1 = require("react");
var useUploadDocument = function () {
    var _a = (0, useMutation_1.useMutation)({
        keysUpdate: [
            keys_1.GET_MY_DOCUMENTS_IDENTITY,
            keys_1.GET_MY_DOCUMENTS_ADDRESS,
            keys_1.GET_MY_DOCUMENTS_PAYMENT,
            keys_1.USER_KYC,
        ],
        path: keys_1.UPLOAD_MY_DOCUMENTS,
    }), mutate = _a.mutate, isSubmitting = _a.isSubmitting, error = _a.error;
    var uploadDocument = (0, react_1.useCallback)(function (data) {
        var form = new FormData();
        form.append('file', data === null || data === void 0 ? void 0 : data.file);
        form.append('type', String(data === null || data === void 0 ? void 0 : data.type));
        mutate(form);
    }, [mutate]);
    return (0, react_1.useMemo)(function () { return ({
        uploadDocument: uploadDocument,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [uploadDocument, isSubmitting, error]);
};
exports.useUploadDocument = useUploadDocument;
